import { combineReducers } from "redux";
import permission from "./PermissionReducer";

export default combineReducers({ permission });
